<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Detail Channel"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="detailForm" :model="detailForm" disabled @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Name" prop="name" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="detailForm.name"
                                placeholder="Name"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Channel Code"
                            prop="channel_code"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="detailForm.channel_code"
                                placeholder="Channel Code"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Delivery"
                            prop="delivery"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="detailForm.delivery"
                                placeholder="Delivery"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Status" size="small" prop="status">
                            <el-radio-group v-model="detailForm.status">
                                <el-radio :label="1">Open</el-radio>
                                <el-radio :label="2">Close</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="detailVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            detailForm: {
                name: "",
                channel_code: "",
                delivery: "",
                status: "",
            },
            roleList: [],
        };
    },
    methods: {
        channel() {
            cmofferApi.channel({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    let { data } = res;
                    this.detailForm = {
                        name: data.name,
                        channel_code:data.channel_code,
                        delivery: data.delivery,
                        status: data.status,
                    };
                }
            });
        },
        save() {
            this.loading = true;
            cmofferApi
                .channel(
                    {
                        ...this.detailForm,
                    },
                    "post",
                    this.tableItem.id
                )
                .then((res) => {
                    this.loading = false;
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.closeDialog();
                    this.$parent[this.funcName]();
                });
        },
        closeDialog() {
            this.$refs["detailForm"].clearValidate();
            this.$refs["detailForm"].resetFields();
            this.$emit("update:detailVisible", false);
        },
        async initialize() {
            this.channel();
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        detailVisible() {
            if (this.detailVisible) {
                this.channel();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.detail {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
